"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_sdk_1 = require("aws-sdk");
const mapper_1 = __importDefault(require("./mapper"));
const DynamoUtils = __importStar(require("../services/dynamodb"));
class DBMapper extends mapper_1.default {
    constructor(name, schema, config) {
        super(name, schema);
        this.db = new aws_sdk_1.DynamoDB.DocumentClient(config === null || config === void 0 ? void 0 : config.DynamoDBOptions);
    }
    async load(ID) {
        const params = {
            TableName: this.getDBName(),
            Key: { ID: ID },
        };
        try {
            const data = await this.db.get(params).promise();
            if (!data.Item) {
                console.log(`${this.name} with ID ${ID} does not exist`);
                return;
            }
            console.log(`successfully loaded ${this.name} with ID ${ID}`);
            const result = this.newModel(data.Item, 'loaded');
            return result;
        }
        catch (ex) {
            console.log(`Error loading ${this.name} with ID ${ID}`, ex);
            throw ex;
        }
    }
    async loadBatch(IDs) {
        const mappedIDs = IDs.map(ID => {
            return { ID: ID };
        });
        const chunkedMappedIDs = DynamoUtils.chunkArray(mappedIDs, 100); // Dynamo batchGets are limited to 100 items
        if (!chunkedMappedIDs.length || !chunkedMappedIDs[0].length)
            return [];
        const paramArray = chunkedMappedIDs.map(IDs => ({
            RequestItems: {
                [this.getDBName()]: {
                    Keys: IDs
                },
            },
        }));
        try {
            const getBatch = async (params) => {
                const res = await this.db.batchGet(params).promise();
                if (!res.Responses || !res.Responses[this.getDBName()]) {
                    console.log(`${this.getDBName()} do not exist with IDs`, JSON.stringify(IDs));
                    return [];
                }
                const result = res.Responses[this.getDBName()].map(i => this.newModel(i, 'loaded'));
                return result;
            };
            const result = [];
            for (let i = 0; i < paramArray.length; i++) {
                const res = await getBatch(paramArray[i]);
                result.push(...res);
            }
            return result;
        }
        catch (ex) {
            console.log(`Error loading ${this.getDBName()} with IDs`, JSON.stringify(IDs), ex);
            throw ex;
        }
    }
    async batchCommit(models, batchSize = 25) {
        const modelsToCommit = [...models];
        //Validate all models before committing
        const validations = modelsToCommit.map(async (model) => {
            const castModel = model;
            castModel.cast();
            const error = await castModel.validate();
            if (error)
                throw error;
        });
        await Promise.all(validations);
        while (modelsToCommit.length) {
            const updates = modelsToCommit.splice(0, batchSize).map(model => {
                const castModel = model;
                if (!castModel.created)
                    castModel.created = new Date().getTime();
                castModel.updated = new Date().getTime();
                return {
                    PutRequest: {
                        Item: DynamoUtils.removeEmptyFields(castModel.toDB()),
                    }
                };
            });
            await this.db.batchWrite({
                RequestItems: {
                    [this.getDBName()]: updates
                }
            }).promise();
        }
    }
    async batchDelete(models, batchSize = 25) {
        const modelsToDelete = [...models];
        while (modelsToDelete.length) {
            const deletes = modelsToDelete.splice(0, batchSize).map(model => {
                const castModel = model;
                return {
                    DeleteRequest: {
                        Key: {
                            [castModel.ID]: DynamoUtils.removeEmptyFields(castModel.toDB()),
                        }
                    }
                };
            });
            await this.db.batchWrite({
                RequestItems: {
                    [this.getDBName()]: deletes
                }
            }).promise();
        }
    }
    async queryAll(startKey) {
        const params = {
            TableName: this.getDBName(),
        };
        if (startKey)
            params.ExclusiveStartKey = startKey;
        try {
            const data = await this.db.scan(params).promise();
            console.log(`successfully queried all ${this.name}s`, data.Items.length, 'results');
            const result = data.Items.map(i => this.newModel(i, 'loaded'));
            if (!data.hasOwnProperty('LastEvaluatedKey') || !data.LastEvaluatedKey) {
                return result;
            }
            console.log('continuing paginated query');
            return this.queryAll(data.LastEvaluatedKey).then(moreResults => {
                let concatedResults = result.concat(moreResults);
                return concatedResults;
            });
        }
        catch (ex) {
            console.log(`Error quering all ${this.name}s`);
            throw ex;
        }
    }
    async query(query) {
        const filters = query.filters || {};
        const ExpressionAttributeValues = DynamoUtils.queryToAttributeValues(Object.assign(Object.assign({}, query.conditions), filters));
        const params = {
            TableName: this.getDBName(),
            IndexName: query.index,
            ExpressionAttributeValues: ExpressionAttributeValues,
            KeyConditionExpression: DynamoUtils.queryToExpression(query.conditions),
            ScanIndexForward: query.ascending
        };
        if (!params.IndexName)
            delete params.IndexName;
        if (query.size)
            params.Limit = query.size;
        if (Object.keys(filters).length > 0)
            params.FilterExpression = DynamoUtils.queryToExpression(filters);
        if (query.hasOwnProperty('ExclusiveStartKey'))
            params.ExclusiveStartKey = query.ExclusiveStartKey;
        console.log(`Querying ${this.name}s with conditions`, query.conditions, 'and filters', filters);
        params.ExpressionAttributeNames = DynamoUtils.getAttributeValueNames(Object.assign(Object.assign({}, filters), query.conditions));
        try {
            const data = await this.db.query(params).promise();
            console.log(`successfully queried ${this.name}s with conditions`, query.conditions, 'and filters', filters, 'with', data.Items.length, 'results');
            const result = data.Items.map(i => this.newModel(i, 'loaded'));
            if (!data.hasOwnProperty('LastEvaluatedKey') || !data.LastEvaluatedKey || (query.size && data.Items.length >= query.size)) {
                return result;
            }
            console.log('continuing paginated query');
            query.ExclusiveStartKey = data.LastEvaluatedKey;
            return this.query(query).then(moreResults => {
                let concatedResults = result.concat(moreResults);
                return concatedResults;
            });
        }
        catch (ex) {
            console.log(`Error quering ${this.name}s with conditions`, query.conditions, 'and filters', filters, ex);
            throw ex;
        }
    }
    async commit(model) {
        if (!model.created)
            model.created = new Date().getTime();
        model.updated = new Date().getTime();
        const params = {
            TableName: this.getDBName(),
            Item: DynamoUtils.removeEmptyFields(model.toDB()),
        };
        console.log(`committing ${this.name} with ID ${model.ID}`);
        try {
            await this.db.put(params).promise();
            console.log(`successfully committed ${this.name} with ID ${model.ID}`);
            return;
        }
        catch (ex) {
            console.log(`error committing ${this.name} with ID ${model.ID}`);
            throw ex;
        }
    }
    update(ID, updates, expression = 'SET', returnValue = 'NONE', upsert = false) {
        let ExpressionAttributeNames = {};
        let ExpressionAttributeValues = {};
        let UpdateExpression = expression;
        for (let index in updates) {
            if (typeof updates[index] === 'object' && expression === 'ADD') {
                for (let objIndex in updates[index]) {
                    ExpressionAttributeNames[`#${objIndex}`] = objIndex;
                    UpdateExpression +=
                        (UpdateExpression === expression ? ' ' : ', ') +
                            `${index}.#${objIndex} :${index}_${objIndex}`;
                    if (Array.isArray(updates[index][objIndex]))
                        ExpressionAttributeValues[`:${index}_${objIndex}`] = this.db.createSet(updates[index][objIndex]);
                    else
                        ExpressionAttributeValues[`:${index}_${objIndex}`] =
                            updates[index][objIndex];
                }
            }
            else {
                UpdateExpression +=
                    (UpdateExpression === expression ? ' ' : ', ') +
                        `${index} ${expression === 'SET' ? '=' : ''} :${index}`;
                ExpressionAttributeValues[`:${index}`] = updates[index];
            }
        }
        return new Promise((resolve, reject) => {
            updates.updated = new Date().getTime();
            const params = {
                TableName: this.getDBName(),
                Key: { ID: ID },
                UpdateExpression: UpdateExpression,
                ExpressionAttributeValues: ExpressionAttributeValues,
                ReturnValues: returnValue,
            };
            if (Object.keys(ExpressionAttributeNames).length > 0)
                params.ExpressionAttributeNames = ExpressionAttributeNames;
            if (!upsert) {
                params.ExpressionAttributeValues[':ID'] = ID;
                params.ConditionExpression = 'ID = :ID';
            }
            console.log(`updating ${this.name} with ID ${ID}`);
            this.db.update(params, (err, data) => {
                if (err) {
                    console.log(`error updating ${this.name} with ID ${ID}`);
                    return reject(err);
                }
                data = data.Attributes || data;
                console.log(`successfully updated ${this.name} with ID ${ID}`);
                return resolve(data);
            });
        });
    }
    async delete(model) {
        const params = {
            TableName: this.getDBName(),
            Key: {
                ID: model.ID,
            },
        };
        console.log(`deleting ${this.name} with ID ${model.ID}`);
        // Call DynamoDB to add the item to the table
        try {
            await this.db.delete(params).promise();
            console.log(`successfully deleted ${this.name} with ID ${model.ID}`);
            return;
        }
        catch (ex) {
            console.log(`error deleting ${this.name} with ID ${model.ID}`);
            throw ex;
        }
    }
    setDynamoDBOptions(options) {
        this.db = new aws_sdk_1.DynamoDB.DocumentClient(options);
    }
}
exports.default = DBMapper;
